import React, { createContext, useState, useContext, useEffect } from 'react';

// Import des fichiers de traduction
import frTranslations from '../locales/fr/translation.json';
import enTranslations from '../locales/en/translation.json';
import esTranslations from '../locales/es/translation.json';
import deTranslations from '../locales/de/translation.json';

// Objet contenant toutes les traductions
const translations = {
  fr: frTranslations,
  en: enTranslations,
  es: esTranslations,
  de: deTranslations
};

// Langues disponibles
export const availableLanguages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

// Créer le contexte
const LanguageContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage doit être utilisé dans un LanguageProvider');
  }
  return context;
};

// Provider du contexte
export const LanguageProvider = ({ children }) => {
  // Récupérer la langue sauvegardée ou utiliser le français par défaut
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('moviefrenzy-language');
    return savedLanguage || 'fr';
  });

  // Sauvegarder la langue dans localStorage quand elle change
  useEffect(() => {
    localStorage.setItem('moviefrenzy-language', currentLanguage);
  }, [currentLanguage]);

  // Fonction pour changer de langue
  const changeLanguage = (languageCode) => {
    if (translations[languageCode]) {
      setCurrentLanguage(languageCode);
    }
  };

  // Fonction pour obtenir une traduction
  const t = (key) => {
    const keys = key.split('.');
    let translation = translations[currentLanguage];
    
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // Si la traduction n'existe pas, retourner la clé
        return key;
      }
    }
    
    return translation;
  };

  // Fonction pour obtenir la langue actuelle
  const getCurrentLanguage = () => {
    return availableLanguages.find(lang => lang.code === currentLanguage);
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    getCurrentLanguage,
    availableLanguages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 